module.exports = __webpack_public_path__ + "static/media/w_35.10319c7d.png";